/**
 * An MCP client's authorization request waiting for the login to finish — BCM360-383. The API
 * sends the browser to /mcp/authorize; a user who is not logged in goes through the normal login
 * (with 2FA or e-mail code) first and is then brought back. Per browser and per tab, like the
 * login's own pending steps, so sessionStorage.
 */
const MCP_RETURN_KEY = "mcpAuthorizeReturn";

export const rememberMcpAuthorize = (url: string) => {
	try {
		sessionStorage.setItem(MCP_RETURN_KEY, url);
	} catch {
		// without storage the user simply starts the connection again from the client
	}
};

export const pendingMcpAuthorize = (): string | null => {
	try {
		const url = sessionStorage.getItem(MCP_RETURN_KEY);

		return url?.startsWith("/mcp/authorize") ? url : null;
	} catch {
		return null;
	}
};

export const clearMcpAuthorize = () => {
	try {
		sessionStorage.removeItem(MCP_RETURN_KEY);
	} catch {
		// nothing to clear
	}
};
